import { IpService } from 'src/app/services/ip.service';
import { RdService } from 'src/app/services/rd.service';
import { ChangeDetectorRef, Component, NgZone, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ScreenService } from './screen.service';
import { Router } from '@angular/router';
import { MatSelect } from '@angular/material/select';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { NgForm } from '@angular/forms';
import { LoaderService } from 'src/app/services/loader.service';
import { SURVEY_TRACKING_MESSAGES, SurveyTrackingMessageKey } from 'src/app/models/TrackUpdate';
import { environment } from 'src/environments/environment';
import { asQueryString } from 'src/app/models/user-params-models';
@Component({
  selector: 'app-screen',
  templateUrl: './screen.component.html',
  styleUrls: ['./screen.component.css'],
})
export class ScreenComponent implements OnInit {
  selectedOptions: string[] = [];
  selectedDate: Date | null;
  questionData: any = null;
  type: string = '';
  date: number;
  isFormSubmitted = false;
  selectedOption: string = '';
  today: Date;
  loading: boolean = false;
  @ViewChild(MatSelect) selectRef: MatSelect;

  constructor(
    private loaderService: LoaderService,
    private _service: ScreenService,
    private _router: Router,
    private cdr: ChangeDetectorRef,
    private zone: NgZone,
    private rdService: RdService,
    private IpService: IpService
  ) { }

  ngOnInit() {
    this.GetQuestion();
  }

  // Function to get the question data from the server
  async GetQuestion(): Promise<void> {
    this.isFormSubmitted = false;
    this.zone.run(() => {
      this.loaderService.show()
      this.loading = true; // Ensure Angular runs change detection
    });
    if (this._service.LogId === undefined || this._service.Mode === undefined) {
      this._router.navigate(['/'])
      this.loaderService.hide()
    } else {
      this._service.GetUserQuestion(this._service.LogId, this._service.Mode).subscribe(async (res: any) => {
        if (res && res.status === 200 && Object.keys(res.body?.data).length > 0) {
          this.questionData = res?.body?.data?.data;
          console.log(this.questionData)
          this.type = this.questionData.type
          console.log(this.type)
          this.loaderService.hide()

        } else if (Object.keys(res?.body?.data).length === 0) {
          // If no data is received, redirect to the client URL
          setTimeout(() => {
            this.loaderService.hide()
          }, 500);
          await this.sendAndMarkSent('REDIRECT_TO_CLIENT', this._service.LogId, this._service.Mode);
          setTimeout(() => {
            window.location.href = this._service.ClientUrl.toString();
          }, 0);
        } else {
          console.log('No data received');
          this.loaderService.hide()

        }
        this.loading = false;
      }, (error) => {
        console.error('Error fetching question:', error);
        this.loading = false;
        this.loaderService.hide()
      });
    }
  }


  // Method to save survey temp data
  async saveSurveyUserTempData(pageName?: string): Promise<void> {
    try {

      const userParam = {
        tforid: '0',
        utype: '0',
        qparm: asQueryString(this._service.LogId, '0'),
        mode: this._service.Mode,
        ip: this.IpService.getIPAddresss(),
        surveyId: 0,
      };

      if (this._service.LogId) {
        const tempDataUrl = this.rdService.getSurveyUserTempDataSaveUrl();
        const jsonData = JSON.stringify(userParam);
        const blob = new Blob([jsonData], { type: 'application/json' });

        // Try using sendBeacon first (fire-and-forget)
        const success = navigator.sendBeacon(`${tempDataUrl}/${pageName}`, blob);

        // If sendBeacon fails (for example, in some browsers), fallback to fetch
        if (!success) {
          console.warn('Beacon request failed, attempting fetch fallback.');
          const response = await fetch(`${tempDataUrl}/${pageName}`, {
            method: 'POST',
            body: blob,
            headers: { 'Content-Type': 'application/json' },
          });

          if (!response.ok) {
            throw new Error(`Fetch failed with status ${response.status}`);
          }
        }
      }
    } catch (error) {
      console.error('Error saving survey user temp data:', error);
    }
  }

  private buildTrackingMessage(
    key: SurveyTrackingMessageKey,
    params?: { status?: number }
  ): string {

    let message: string = SURVEY_TRACKING_MESSAGES[key];

    if (params?.status !== undefined) {
      message = message.replace('{status}', String(params.status));
    }

    return message;
  }

  private async sendAndMarkSent(
    key: SurveyTrackingMessageKey,
    logId: any,
    mode: any,
    params?: { status?: number }
  ): Promise<void> {

    const message: string = this.buildTrackingMessage(key, params);
    try {
      await fetch(`${environment.baseUrl}callbacks/TrackUpdate`, {
        method: 'POST',
        body: JSON.stringify({ toid: logId, message, mode }),
        headers: { 'Content-Type': 'application/json' },
        keepalive: true
      });
    } catch {
      // do nothing — redirect should still happen
      try {
        await this.saveSurveyUserTempData(SURVEY_TRACKING_MESSAGES.ERROR_IN_TrackUpdate)
      } catch { }
    }
  }

  // Function to determine what data to send based on the question type
  getResponseData() {
    if (this.type === 'Range') {
      return this.getAgeAndSendData();
    } else if (this.type === "DropDown Multi Select") {
      return this.selectedOptions.map(option => `${option}`).join(",");
    } else {
      return this.selectedOption;
    }
  }

  // Function to save the user response
  onSubmit(form: NgForm) {
    this.loading = true;
    this.loaderService.show()
    // Manually trigger change detection to reflect this change in the view
    this.cdr.detectChanges();
    this.isFormSubmitted = true;
    if (form.valid && this.isValidSelection()) {
      const payload = {
        "logId": this._service.LogId,
        "questionId": this.questionData.id,
        "response": this.getResponseData(),
        "mode": this._service.Mode
      };
      // Make the API call to save the response
      this._service.SaveUserAnswer(payload).subscribe({
        next: (response: HttpResponse<any>) => {
          if (response && response.status === 200) {
            if (response.body?.data?.data.status === "OK") {
              this.selectedOption = '';
              this.GetQuestion();
            }
          } else if (response && response.status === 302) {
            this._router.navigate(['/']);
          }
          this.loading = false;
          this.loaderService.show();
          this.cdr.detectChanges();
        },
        error: async (error: HttpErrorResponse) => {
          console.error('Error saving user response:', error);

          // Handle error more explicitly for 302 redirection
          if (error.status === 302) {
            this.isFormSubmitted = false;
            this.loading = false;
            this.loaderService.hide()
            this.cdr.detectChanges();
            const status = this.getStatusFromCallbackUrl(error.error.data.data.terminateUrl);

            await this.sendAndMarkSent('REDIRECT_TO_CALLBACK', this._service.LogId, this._service.Mode, { status });
            setTimeout(() => {
              window.location.href = error.error.data.data.terminateUrl// this._router.navigate(['/']);  // Redirect user to login

            }, 0);
          } else {
            this.loaderService.hide()

          }
        }
      });
    } else {
      console.log('Form is invalid');
      this.loading = false;
      this.loaderService.hide();
    }
  }

  private getStatusFromCallbackUrl(url: string): number | null {
    try {
      const parsedUrl = new URL(url);
      const status = parsedUrl.searchParams.get('s');
      return status ? Number(status) : null;
    } catch {
      return null;
    }
  }
  // Function to remove a selected chip from the options
  removeChip(option: string) {
    const index = this.selectedOptions.indexOf(option);
    if (index > -1) {
      this.selectedOptions.splice(index, 1);
      this.selectRef.value = [...this.selectedOptions];
    }
  }

  isChecked(value: string): boolean {
    return this.selectedOptions.includes(`${value}`);
  }

  onOptionChange(value: string, event: Event) {
    const checkbox = event.target as HTMLInputElement;
    const isChecked = checkbox.checked;

    if (isChecked) {
      if (this.selectedOption) {
        this.selectedOption += `,${value}`;
      } else {
        this.selectedOption = `${value}`;
      }
    } else {
      const optionToRemove = `${value}`;
      this.selectedOption = this.selectedOption.replace(optionToRemove, '');
      this.selectedOption = this.selectedOption.replace(/^,|,$/g, '');  // Clean up any commas
    }
  }

  // calculateAge(selectedDate: Date): number {
  //   const currentDate = new Date();

  //   // Calculate the difference in full years
  //   let age = currentDate.getFullYear() - selectedDate.getFullYear();

  //   const currentMonth = currentDate.getMonth();
  //   const currentDay = currentDate.getDate();
  //   const birthMonth = selectedDate.getMonth();
  //   const birthDay = selectedDate.getDate();

  //   // Adjust if the current month and day are before the birth month and day
  //   if (currentMonth < birthMonth || (currentMonth === birthMonth && currentDay < birthDay)) {
  //     age--;
  //   }

  //   // Calculate the total months difference
  //   const monthDiff = (currentDate.getFullYear() - selectedDate.getFullYear()) * 12 + (currentMonth - birthMonth);

  //   // Determine the fraction of the year (using months as the base)
  //   const monthFraction = (monthDiff % 12) / 12;

  //   // Calculate exact age, adding fractional year based on month difference
  //   let exactAge = age + monthFraction;

  //   // Round to the nearest 0.5 years
  //   exactAge = Math.round(exactAge * 2) / 2;

  //   return exactAge;
  // }
  calculateExactAge(selectedDate: Date): { years: number, months: number, days: number } {
    const today = new Date();

    let years = today.getFullYear() - selectedDate.getFullYear();
    let months = today.getMonth() - selectedDate.getMonth();
    let days = today.getDate() - selectedDate.getDate();

    // Adjust months if negative
    if (months < 0) {
      years--;
      months += 12;
    }

    // Adjust days if negative
    if (days < 0) {
      months--;
      const previousMonth = new Date(today.getFullYear(), today.getMonth(), 0);
      days += previousMonth.getDate();
    }

    return { years, months, days };
  }






  getAgeAndSendData() {
    const age = this.calculateExactAge(this.selectedDate);
    return `${age.years} years-${age.months} months-${age.days} days`;
  }


  isValidSelection() {
    if (this.type === 'Single Select' || this.type === 'Dropdown single select') {
      return this.selectedOption != null && this.selectedOption !== '';
    } else if (this.type === 'Multi Select') {
      return this.selectedOption && this.selectedOption !== '';
    } else if (this.type === 'DropDown Multi Select') {
      return this.selectedOptions && this.selectedOptions.length > 0;
    } else if (this.type === 'Open End') {
      return this.selectedOption && this.selectedOption.trim() !== '';
    } else if (this.type === 'Range') {
      return this.selectedDate != null;
    }
    return false;
  }

}
